import styled from "styled-components"
import ContactezNous from "../assets/undraw_mail.svg"
import Validate from "../assets/order-confirmed.svg"
import Warning from "../assets/undraw_warning.svg"

const ContactezNousImage = styled(ContactezNous)`
  width: 70%;
  height: 550px;
  display: block;
  margin: 1.25rem 0 0 auto;
  & *[fill="#6c63ff"] {
    fill: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  @media (max-width: 900px) {
    display: none;
  }
`

const ValidateImage = styled(Validate)`
  width: 70%;
  height: 500px;
  display: block;
  margin: 1.25rem auto 0 auto;
  & *[fill="#6c63ff"] {
    fill: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  @media (max-width: 900px) {
    width: 90%;
    height: 250px;
  }
`

const WarningImage = styled(Warning)`
  width: 70%;
  height: 500px;
  display: block;
  margin: 1.25rem auto 0 auto;
  & *[fill="#6c63ff"] {
    fill: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  & *[fill="#464353"] {
    fill: ${(props) => props.theme.a_color_gradients.a_dark};
  }
  @media (max-width: 900px) {
    width: 90%;
    height: 250px;
  }
`

const Title = styled.h2`
  &::after {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`

export { ContactezNousImage, Title, ValidateImage, WarningImage }
